import React, {useRef} from "react"
import {Box} from "@mui/material"
import {DndContext, useDroppable} from "@dnd-kit/core"
import EventMarker from "./EventMarker"
import {
    calculateDateProgressPercentage,
    getDateFromCursorX,
    percentToPx,
} from "./time-utils"

const EventLayer = ({
    events = [],
    startYear,
    endYear,
    onEventsChange,
    leftOffsetPx,
    widthPx,
    height,
}) => {
    const areaRef = useRef(null)
    const {setNodeRef} = useDroppable({id: "events-area"})

    const handleDragEnd = (event) => {
        const {active, delta} = event
        if (!areaRef.current) return

        const dragged = events.find((e) => e.id === active.id)
        if (!dragged?.date) return

        const startPct = calculateDateProgressPercentage(dragged.date, startYear, endYear)
        if (Number.isNaN(startPct)) return

        const originalLeftPx = percentToPx(startPct, widthPx)
        const newX = Math.min(Math.max(0, originalLeftPx + delta.x), widthPx)
        const newDate = getDateFromCursorX(newX, 0, widthPx, startYear, endYear)
        if (Number.isNaN(newDate.getTime())) return

        const dateStr = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}`
        const updated = events.map((e) =>
            e.id === active.id ? {...e, date: dateStr} : e,
        )
        onEventsChange(updated)
    }

    const eventsWithDate = events.filter((evt) => evt.date)

    return (
        <DndContext onDragEnd={handleDragEnd}>
            <Box
                ref={(node) => {
                    areaRef.current = node
                    setNodeRef(node)
                }}
                sx={{
                    position: "absolute",
                    left: `${leftOffsetPx}px`,
                    width: `${widthPx}px`,
                    top: 0,
                    height: `${height}px`,
                    pointerEvents: "none",
                }}
            >
                {eventsWithDate.map((evt) => {
                    const pct = calculateDateProgressPercentage(evt.date, startYear, endYear)
                    if (Number.isNaN(pct)) return null
                    const leftPx = percentToPx(pct, widthPx)
                    return (
                        <EventMarker
                            key={evt.id}
                            event={evt}
                            leftPx={leftPx}
                            dashHeight={height}
                        />
                    )
                })}
            </Box>
        </DndContext>
    )
}

export default EventLayer
